<div class="toolbar-container">
  <i class="icon-burger" (click)="openMobileMenu.emit()"></i>
  <img src="assets/ncss-wordmark-blue.svg" (click)="homeClicked.emit(Links.HOME)">
</div>
